/* eslint-disable react/jsx-closing-bracket-location */

import React from 'react';

import { withTranslation } from 'providers/GILT.provider';

class TableSortHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDateAsc: true,
      isReipientsAsc: true,
      isSmsCountsAsc: true,
      isCostAsc: true,
    };
  }

  render() {
    const { sortFunction, sortAutoSmsByMonth, t } = this.props;

    return (
      <div className="sticky-navbar-automsg">
        <table className="tbl-automsg-sort">
          <tbody>
            <tr>
              <td className="date-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortFunction('dateSent', this.state.isDateAsc);
                    this.setState({ isDateAsc: !this.state.isDateAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.dateSent')}
                </span>
              </td>
              <td className="target-width">
                <span className="sort-btn no-arrow">{t('campaigns.tableHeaders.audience')}</span>
              </td>
              <td className="message-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortAutoSmsByMonth('recipients', this.state.isReipientsAsc);
                    this.setState({ isReipientsAsc: !this.state.isReipientsAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.recipients')}
                </span>
              </td>
              <td className="sms-sent-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortAutoSmsByMonth('smsCount', this.state.isSmsCountsAsc);
                    this.setState({ isSmsCountsAsc: !this.state.isSmsCountsAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.sentTexts')}
                </span>
              </td>
              <td className="booking-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortAutoSmsByMonth('bookingReceived', this.state.isSmsCountsAsc);
                    this.setState({ isSmsCountsAsc: !this.state.isSmsCountsAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.bookings')}
                </span>
              </td>
              <td className="revenue-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortAutoSmsByMonth('revenue', this.state.isSmsCountsAsc);
                    this.setState({ isSmsCountsAsc: !this.state.isSmsCountsAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.revenue')}
                </span>
              </td>
              <td className="sms-cost-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortAutoSmsByMonth('smsCost', this.state.isCostAsc);
                    this.setState({ isCostAsc: !this.state.isCostAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.textsCost')}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default withTranslation()(TableSortHeader);
